/* Полоса «Мнение автора» — орган ЭКРАНА, а не превью, и стоит снаружи `.tgzone`, как полосы
   визуала и файла: фирменные токены здесь и делают видимой границу «здесь кончается чужой
   клиент». Геометрия совпадает с `DocumentStrip.module.css` один в один: полосы под постом —
   один ряд органов, и разная посадка читалась бы как разная природа. Ни одного цвета литералом
   (правило docs/frontend.md). */

.strip {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--r-card);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  min-width: 0;
}

.head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

/* Мнение — слова человека, а не данные: обычный текст, с переносом длинных слов и адресов
   (ссылку автор мог вставить без пробелов) и со строками, как их набрали. Линейка слева — та
   же подложка акцента, что у чипов: цитата, а не плашка предупреждения. */
.quote {
  margin: 0;
  padding: 2px 0 2px 12px;
  border-left: 2px solid var(--violet-bg-2);
  font-size: 13px;
  line-height: 1.5;
  color: var(--ink);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  min-width: 0;
}

.actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

/* Подпись поля и ⓘ одной строкой в диалоге мнения. */
.fieldHead {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Счётчик сверх потолка бренда — цветом отказа: сохранить такое мнение бэкенд не даст.
   Селектор сильнее `.lmeter .cnt` из base.css, а не равен ему: при равенстве цвет решал бы
   порядок подключения стилей. */
:global(.lmeter) :global(.cnt).over {
  color: var(--red-ink);
}
